module.exports = __webpack_public_path__ + "static/media/logout.84028fcc.svg";